import { createElement, lazy, Suspense, type ComponentProps, type ComponentType } from 'react';

// Keep lazy SDK components usable at call sites without repeating Suspense wrappers.
export function lazyComponent<TComponent extends ComponentType<any>>(
  loader: () => Promise<{ default: TComponent }>
): TComponent {
  const Component = lazy(loader);

  return function LazyComponent(props: ComponentProps<TComponent>) {
    return createElement(Suspense, { fallback: null }, createElement(Component, props));
  } as TComponent;
}
